import * as React from 'react';
import * as style from './FactsWrapper.css';

export const FactsWrapper = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={style['wrapper']}>
      <ul className={style['inner']}>{children}</ul>
    </div>
  );
};
